import { Component, OnInit,ChangeDetectorRef,ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {MatSnackBar} from '@angular/material';
import { AppSettings } from '../../app.constant';
import { UserService } from '../../shared/services/user.service';
import { UserTableComponent } from '../../private/tables/user-table/user-table.component';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})

export class UserComponent implements OnInit {

  userForm:FormGroup;
  submitted=false;
  roles:any;
  users:any;
  post:any;
  PK_UserID:any;
  FK_RoleID:any;
  UserName:string;
  Password:string;
  FirstName:string;
  LastName:string;
  CreatedDate:string;
  errorMessage: String;
  userEntity:any;
  buttonTitle:String =  'S A V E ';
  newtitle:String =" N E W ";
  httpResponseMessage:any;
  
  @ViewChild(UserTableComponent) usertable;
  constructor(private formBuilder:FormBuilder, 
              private _userService:UserService,
              private snackBar: MatSnackBar,
              changeDetectorRefs: ChangeDetectorRef) { }

  ngOnInit() {
    this.userForm = this.formBuilder.group({
      'PK_UserID':['', Validators.required],
      'FK_RoleID':['', Validators.required],
      'UserName':['', Validators.required],
      'Password':['', Validators.required],
      'FirstName':['', Validators.required],
      'LastName':['', Validators.required],
      'CreatedDate':['', ]
    })
   
    this._userService.refreshNeeded$
    .subscribe(()=>{
      this.getAllRole();
    })

    this.getAllRole();
    this.getAllUser();
  }

  postUser(post) :void  {
    if(post.PK_UserID!='' && post.PK_UserID!=null) {
      this.updateUser(post);
    }
    else{
     this.createUser(post);
    }
  }

  receiveData($event) {
    this.userEntity = $event
    this.PK_UserID=this.userEntity[0].PK_UserID;
    this.FK_RoleID=this.userEntity[0].FK_RoleID;
    this.UserName=this.userEntity[0].UserName;
    this.Password=this.userEntity[0].Password;
    this.FirstName=this.userEntity[0].FirstName;
    this.LastName=this.userEntity[0].LastName;
    this.FirstName=this.userEntity[0].FirstName;
  }

  getAllUser() :void  {
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.loginForm.value))
      // this.post=JSON.stringify();
      // console.log(this.post);
       this._userService.getAllUsers(AppSettings.API_ENDPOINT+AppSettings.GetAllUsers).subscribe(
      data =>
         {
           this.users=data;
      },
      error => this.errorMessage = <any>error)
  }

  getAllRole() :void  {
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.loginForm.value))
      // this.post=JSON.stringify();
      // console.log(this.post);
       this._userService.getAllRole(AppSettings.API_ENDPOINT+AppSettings.GetAllRole).subscribe(
      data =>
         {
           this.roles=data;
      },
      error => this.errorMessage = <any>error)
  }

  createUser(post) :void  {
    this.post=JSON.stringify(post);
      this._userService.postUser(AppSettings.API_ENDPOINT+AppSettings.Createuser,this.post).subscribe(
     data => {
      this.httpResponseMessage="Marksheet  Uploaded....";
              },
     error =>{
      console.log(error.error);
      this.httpResponseMessage=error.error;
     })
     this.openSnackBar(this.httpResponseMessage,'');
  }

  updateUser(post)  {
    if (this.userForm.invalid) {  return;  }
    this.post=JSON.stringify(post);
    this._userService.updateUser(AppSettings.API_ENDPOINT+AppSettings.UpdateUser,this.post).subscribe(
      data =>{   
              this.httpResponseMessage=data;
              this.openSnackBar(this.httpResponseMessage,'');
              this.userForm.reset();
              },
      error =>{
              console.log(error.error);
              this.httpResponseMessage=error.error;
              this.openSnackBar(this.httpResponseMessage,'');
              })
       
  }

  createRole(post) :void  {
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.loginForm.value))
      
       this.post=JSON.stringify(post);
       console.log(this.post);
       this._userService.postRole(AppSettings.API_ENDPOINT+AppSettings.CreateRole,this.post).subscribe(
      data =>
         {
      },
      error => this.errorMessage = <any>error)
  }

  cleardata()
  {
  this.userForm.reset();
  }

  durationInSeconds = 2;
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message,action ,{
      duration: 2000,
      verticalPosition: 'bottom'
    });
    }

}



